import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles, AlertCircle } from "lucide-react";

export interface OnboardingResult {
  disclaimer_accepted: boolean;
}

interface OnboardingFlowProps {
  onComplete: (data: OnboardingResult) => void;
  isSubmitting: boolean;
}

const OnboardingFlow = ({ onComplete, isSubmitting }: OnboardingFlowProps) => {
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-lg border-border/50 shadow-lg">
        <CardContent className="p-6 md:p-8">
          <div className="text-center mb-6">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
              <Sparkles className="h-8 w-8 text-primary" />
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Bienvenida a Sana Pilates
            </h1>
            <p className="text-muted-foreground">
              Armemos tu experiencia a tu manera.
            </p>
          </div>

          <div className="space-y-6 text-center">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
              <AlertCircle className="h-8 w-8 text-primary" />
            </div>
            <h2 className="text-2xl font-bold text-foreground" style={{ fontFamily: 'Playfair Display, serif' }}>
              Antes de empezar
            </h2>
            <p className="text-muted-foreground leading-relaxed max-w-md mx-auto">
              Este programa no reemplaza el consejo de un profesional de la salud.
              Es una herramienta de acompañamiento para sostener hábitos de bienestar
              a través del movimiento consciente.
            </p>
            <label className="flex items-start gap-3 cursor-pointer text-left max-w-md mx-auto p-4 rounded-xl border border-border hover:border-primary/50 transition-colors">
              <input
                type="checkbox"
                checked={disclaimerAccepted}
                onChange={(e) => setDisclaimerAccepted(e.target.checked)}
                className="mt-1 h-5 w-5 rounded border-border text-primary accent-primary"
              />
              <span className="text-sm text-muted-foreground">
                Entiendo y acepto que este programa es una guía de bienestar y no sustituye la consulta médica profesional.
              </span>
            </label>
            <Button
              onClick={() => onComplete({ disclaimer_accepted: true })}
              disabled={!disclaimerAccepted || isSubmitting}
              className="w-full max-w-md h-12 text-base font-semibold"
            >
              {isSubmitting ? "Guardando..." : "Entendido"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OnboardingFlow;
